import React from "react";

/**
 * ZeoIcon — Animiertes KI-Symbol für den Zeo-Assistenten
 * 
 * Verwendung:
 *   import ZeoIcon from "./ZeoIcon";
 *   <ZeoIcon size={32} />
 */
export default function ZeoIcon({ size = 32, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Olympus KI-Assistent"
      role="img"
    >
      <style>{`
        @keyframes oi-fire-a { 0%,100%{opacity:.15} 15%{opacity:1} 30%{opacity:.15} }
        @keyframes oi-fire-b { 0%,100%{opacity:.15} 15%{opacity:1} 30%{opacity:.15} }
        @keyframes oi-fire-c { 0%,100%{opacity:.15} 15%{opacity:1} 30%{opacity:.15} }
        @keyframes oi-fire-d { 0%,100%{opacity:.15} 15%{opacity:1} 30%{opacity:.15} }
        @keyframes oi-fire-e { 0%,100%{opacity:.15} 15%{opacity:1} 30%{opacity:.15} }
        @keyframes oi-fire-f { 0%,100%{opacity:.15} 15%{opacity:1} 30%{opacity:.15} }
        @keyframes oi-fire-g { 0%,100%{opacity:.15} 15%{opacity:1} 30%{opacity:.15} }
        @keyframes oi-fire-h { 0%,100%{opacity:.15} 15%{opacity:1} 30%{opacity:.15} }
        @keyframes oi-edge-p  { 0%,100%{opacity:.08} 50%{opacity:.55} }
        @keyframes oi-orbit1  { from{transform:rotate(0deg)}   to{transform:rotate(360deg)}  }
        @keyframes oi-orbit2  { from{transform:rotate(120deg)} to{transform:rotate(480deg)}  }
        @keyframes oi-orbit3  { from{transform:rotate(240deg)} to{transform:rotate(600deg)}  }
        @media (prefers-reduced-motion: no-preference) {
          .oi-na { animation: oi-fire-a 3.2s ease-in-out 0.0s  infinite }
          .oi-nb { animation: oi-fire-b 2.8s ease-in-out 0.4s  infinite }
          .oi-nc { animation: oi-fire-c 3.5s ease-in-out 0.9s  infinite }
          .oi-nd { animation: oi-fire-d 2.6s ease-in-out 1.3s  infinite }
          .oi-ne { animation: oi-fire-e 3.1s ease-in-out 1.8s  infinite }
          .oi-nf { animation: oi-fire-f 2.9s ease-in-out 2.2s  infinite }
          .oi-ng { animation: oi-fire-g 3.4s ease-in-out 0.6s  infinite }
          .oi-nh { animation: oi-fire-h 2.7s ease-in-out 1.6s  infinite }
          .oi-ea { animation: oi-edge-p  3.2s ease-in-out 0.2s  infinite }
          .oi-eb { animation: oi-edge-p  2.8s ease-in-out 0.6s  infinite }
          .oi-ec { animation: oi-edge-p  3.5s ease-in-out 1.1s  infinite }
          .oi-ed { animation: oi-edge-p  2.6s ease-in-out 1.5s  infinite }
          .oi-ee { animation: oi-edge-p  3.1s ease-in-out 2.0s  infinite }
          .oi-ef { animation: oi-edge-p  2.9s ease-in-out 2.4s  infinite }
          .oi-eg { animation: oi-edge-p  3.4s ease-in-out 0.8s  infinite }
          .oi-o1 { animation: oi-orbit1 11s linear infinite; transform-origin: 60px 60px }
          .oi-o2 { animation: oi-orbit2 15s linear infinite; transform-origin: 60px 60px }
          .oi-o3 { animation: oi-orbit3 20s linear infinite; transform-origin: 60px 60px }
        }
      `}</style>

      {/* Äußere Ringe */}
      <circle cx="60" cy="60" r="56" fill="none" stroke="#534AB7" strokeWidth="0.8" opacity="0.18"/>
      <circle cx="60" cy="60" r="44" fill="none" stroke="#7F77DD" strokeWidth="0.6" opacity="0.14"/>

      {/* Orbit-Punkte */}
      <g className="oi-o1"><circle cx="60" cy="4"  r="4"   fill="#534AB7" stroke="#AFA9EC" strokeWidth="1.2"/></g>
      <g className="oi-o2"><circle cx="60" cy="4"  r="3"   fill="#7F77DD"  stroke="#CECBF6" strokeWidth="1"/></g>
      <g className="oi-o3"><circle cx="60" cy="4"  r="2.5" fill="#AFA9EC"  stroke="#EEEDFE" strokeWidth="0.8"/></g>

      {/* Kern-Kreis */}
      <circle cx="60" cy="60" r="30" fill="#0D0B2E" stroke="#534AB7" strokeWidth="1.5"/>
      <circle cx="60" cy="60" r="28" fill="none"   stroke="#3C3489" strokeWidth="0.6" opacity="0.5"/>

      {/* Neuronale Kanten */}
      <line className="oi-ea" x1="47" y1="50" x2="60" y2="48" stroke="#7F77DD" strokeWidth="1.2"/>
      <line className="oi-eb" x1="60" y1="48" x2="73" y2="51" stroke="#7F77DD" strokeWidth="1.2"/>
      <line className="oi-ec" x1="47" y1="50" x2="52" y2="62" stroke="#AFA9EC" strokeWidth="1"/>
      <line className="oi-ed" x1="73" y1="51" x2="68" y2="63" stroke="#AFA9EC" strokeWidth="1"/>
      <line className="oi-ea" x1="52" y1="62" x2="60" y2="72" stroke="#AFA9EC" strokeWidth="1.2"/>
      <line className="oi-ec" x1="68" y1="63" x2="60" y2="72" stroke="#AFA9EC" strokeWidth="1.2"/>
      <line className="oi-ee" x1="52" y1="62" x2="68" y2="63" stroke="#7F77DD" strokeWidth="0.8"/>
      <line className="oi-ef" x1="47" y1="50" x2="73" y2="51" stroke="#534AB7" strokeWidth="0.8" opacity="0.5"/>
      <line className="oi-eg" x1="60" y1="48" x2="60" y2="72" stroke="#534AB7" strokeWidth="0.6" opacity="0.3"/>

      {/* Neuronen-Knoten */}
      <g className="oi-na">
        <circle cx="60" cy="48" r="4.5" fill="#3C3489" stroke="#7F77DD" strokeWidth="1.5"/>
        <circle cx="60" cy="48" r="2"   fill="#AFA9EC"/>
      </g>
      <g className="oi-nb">
        <circle cx="47" cy="50" r="3.5" fill="#3C3489" stroke="#7F77DD" strokeWidth="1.5"/>
        <circle cx="47" cy="50" r="1.8" fill="#AFA9EC"/>
      </g>
      <g className="oi-nc">
        <circle cx="73" cy="51" r="3.5" fill="#3C3489" stroke="#7F77DD" strokeWidth="1.5"/>
        <circle cx="73" cy="51" r="1.8" fill="#AFA9EC"/>
      </g>
      <g className="oi-nd">
        <circle cx="52" cy="62" r="4"   fill="#26215C" stroke="#534AB7" strokeWidth="1.5"/>
        <circle cx="52" cy="62" r="2"   fill="#AFA9EC"/>
      </g>
      <g className="oi-ne">
        <circle cx="68" cy="63" r="4"   fill="#26215C" stroke="#534AB7" strokeWidth="1.5"/>
        <circle cx="68" cy="63" r="2"   fill="#AFA9EC"/>
      </g>
      <g className="oi-nf">
        <circle cx="60" cy="72" r="3.5" fill="#3C3489" stroke="#7F77DD" strokeWidth="1.5"/>
        <circle cx="60" cy="72" r="1.8" fill="#AFA9EC"/>
      </g>
      <g className="oi-ng">
        <circle cx="55" cy="56" r="3"   fill="#26215C" stroke="#534AB7" strokeWidth="1.2"/>
        <circle cx="55" cy="56" r="1.5" fill="#CECBF6"/>
      </g>
      <g className="oi-nh">
        <circle cx="65" cy="57" r="3"   fill="#26215C" stroke="#534AB7" strokeWidth="1.2"/>
        <circle cx="65" cy="57" r="1.5" fill="#CECBF6"/>
      </g>
    </svg>
  );
}
